import { Avatar, Button, Drawer, Form, Select, Switch } from "antd";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { authenticateToken } from "../../utils/auth";
import { getPage, jcTypeArray } from "../../utils/index";
import Loading from "../common/Loader";
import PaginationTwo from "../common/PaginationTwo";
import TopHeading from "./TopHeading";
import { CheckOutlined, EditOutlined, CloseOutlined } from "@ant-design/icons";
import moment from "moment";
import Empty from "../common/Empty";
import AddCampaign from "./AddCampaign";
import { responseNotification } from "../../utils/notify";
const { Option } = Select;

const CampaignsList = () => {
  const [type, setType] = useState("JC_MART");
  const [loading, setLoading] = useState(undefined);
  const [visible, setVisible] = useState(undefined);
  const [selectedCampaignForEdit, setSelectedCampaignForEdit] =
    useState(undefined);
  const [selectedCampaign, setSelectedCampaign] = useState(undefined);
  const [isActive, setIsActive] = useState<any>();
  const [isFlashSale, setIsFlashSale] = useState<any>();
  const [limit, setLimit] = useState(16);
  const loc = useLocation();

  const [campaignData, setCampaignData] = useState({
    loading: false,
    data: null,
  });

  const getCampaign = useCallback(async () => {
    setCampaignData({ loading: true, data: null });
    const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
    axios
      .get(
        `${encodedUri}/admin/campaign/by-type?type=${type}` +
          (isFlashSale ? `&isFlashSale=${isFlashSale}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      )
      .then((res) => {
        setCampaignData({ loading: false, data: res.data });
      })
      .catch((err) => {
        setCampaignData({ loading: false, data: [] });
        console.error("Campaign: Error", err);
      });
  }, [isFlashSale, type]);

  useEffect(() => {
    getCampaign();
  }, [getCampaign]);

  // const getCampaignOptions = useCallback(
  //   async (type) => {
  //     setcampaignOptions({ loading: true, list: null });
  //     const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
  //     axios
  //       .get(
  //         `${encodedUri}/campaign?page=${page || 0}` +
  //           `&limit=${limit || 16}` +
  //           (type ? `&type=${type}` : ``) +
  //           (status ? `&status=${status}` : ``),
  //         {
  //           headers: {
  //             Authorization: `Bearer ${authenticateToken()}`,
  //           },
  //         }
  //       )
  //       .then((res) => {
  //         setcampaignOptions({
  //           loading: false,
  //           list: res.data?.campaigns?.map((campaign) => ({
  //             label: campaign.title,
  //             value: campaign.title,
  //           })),
  //         });
  //       })
  //       .catch((err) => {
  //         setcampaignOptions({ loading: false, list: [] });
  //         console.error("campaigns: Error", err);
  //       });
  //   },
  //   [status]
  // );

  //
  const onStatusChange = async (id, val) => {
    setLoading(true);
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/campaign`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);
          if (res.statusCode === 200) {
            responseNotification("Status Changed Successfully", "success");
            getCampaign();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //
  const [form] = Form.useForm();

  const reseAllFieldData = () => {
    setIsFlashSale("");
    setIsActive("");
    setType("JC_MART");
    form.resetFields();
  };

  useEffect(() => {
    if (visible) {
      setSelectedCampaign(undefined);
      setSelectedCampaignForEdit(undefined);
    }
  }, [selectedCampaign, selectedCampaignForEdit, visible]);

  useEffect(() => {
    setSelectedCampaign(undefined);
    setSelectedCampaignForEdit(undefined);
  }, [visible]);

  const onClose = () => {
    setSelectedCampaign(null);
    setSelectedCampaignForEdit(null);
    getCampaign();
  };

  return (
    <React.Fragment>
      <TopHeading
        {...campaignData?.data?.totalElements}
        refetch={getCampaign}
      />

      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="type_search" initialValue={type}>
            <Select
              showSearch
              placeholder="Filter by Type"
              onChange={(val) => setType(val as string)}
            >
              <Select.Option value="">ALL TYPES</Select.Option>
              {Object.values(jcTypeArray)?.map((type, i) => (
                <Select.Option value={type} key={i}>
                  {type.replace("_", " ")}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item initialValue={null}>
            <Select
              placeholder="Status"
              onChange={(val) => setIsFlashSale(val)}
              value={isFlashSale}
            >
              <Option value={""}>ALL</Option>
              <Option value={"false"}>General Campaign</Option>
              <Option value={"true"}>FlahSale Campaign</Option>
            </Select>
          </Form.Item>
        </Form>

        <div className="search_btn">
          <Button type="primary" danger size="large" onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>

      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading">
                    <span>Campaign</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Type</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Color Code</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Starting Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Ending Date</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            {campaignData?.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {campaignData?.data?.campaigns?.length ? (
                    campaignData?.data?.campaigns?.map(
                      (campaign: any, index: any) => (
                        <React.Fragment key={index}>
                          <Link
                            to={`/promotions/campaigns/details/${campaign?.id}`}
                          >
                            <div className="single-product-wrapper">
                              <div className="single-product">
                                <Avatar
                                  shape="square"
                                  size={45}
                                  src={campaign?.banner}
                                  className="mr-3"
                                />
                                <span className="name">{campaign?.name}</span>
                              </div>

                              <div className="single-product">
                                <span className="name">
                                  {campaign?.type?.replace("_", " ")}
                                </span>
                              </div>
                              <div className="single-product">
                                <Avatar
                                  style={{
                                    background: campaign?.colorCode,
                                    marginRight: 10,
                                  }}
                                ></Avatar>
                                <span className="name mr-2">
                                  {campaign?.colorCode}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {moment(campaign?.startAt).format("lll")}
                                </span>
                              </div>
                              <div className="single-product">
                                <span className="name">
                                  {moment(campaign?.endAt).format("lll")}
                                </span>
                              </div>

                              <div className="single-product">
                                <Switch
                                  checkedChildren={<CheckOutlined />}
                                  unCheckedChildren={<CloseOutlined />}
                                  defaultChecked={campaign?.isActive}
                                  onChange={(val, e) => {
                                    e.preventDefault();
                                    e.stopPropagation();
                                    onStatusChange(campaign?.id, val);
                                  }}
                                  loading={loading && campaign?.id === loading}
                                  title="Active/Inactive"
                                />
                              </div>

                              <div className="single-product">
                                <Button
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setSelectedCampaignForEdit(campaign);
                                  }}
                                >
                                  <EditOutlined />
                                </Button>
                              </div>
                            </div>
                          </Link>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Campaigns" />
                  )}
                </div>
              </div>
            )}
          </div>

          <Drawer
            title={"Edit Campaign"}
            width={600}
            onClose={() => {
              setSelectedCampaign(null);
              setSelectedCampaignForEdit(null);
            }}
            visible={selectedCampaignForEdit}
            bodyStyle={{ paddingBottom: 80 }}
            footer={
              <div
                style={{
                  textAlign: "right",
                }}
              ></div>
            }
          >
            <AddCampaign
              visibleData={selectedCampaignForEdit}
              onCloseMethod={onClose}
            />
          </Drawer>

          <PaginationTwo
            {...campaignData?.data}
            limit={limit}
            page={getPage(loc.search)}
          />
        </div>
      </div>
    </React.Fragment>
  );
};

export default CampaignsList;
